import React from "react";
import ReactModal from "react-modal";
import Button from "../../Button";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  status: "valid" | "invalid";
  message?: string;
}

const customStyles = {
  content: {
    top: "50%",
    left: 0,
    right: 0,
    bottom: "auto",
    margin: "0 auto",
    transform: "translateY(-50%)",
    padding: "0 10px",
    width: "90%",
    maxWidth: "360px",
    maxHeight: "200px",
  },
  overlay: {
    zIndex: 100002,
  },
};



const CardStatusDialog = ({ isOpen, onClose, status, message }: Props) => {
  const isValid = status === "valid";
  const title = isValid ? "Carte BTP valide" : "Carte BTP invalide";
  const body = message ?? (isValid ? "La carte a été vérifiée avec succès." : "La carte n'est pas valide.");

  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel={title}
      appElement={document.getElementById("root") ?? undefined}
      style={customStyles}
    >
      <div className="flex flex-col items-center justify-center h-full gap-2">
        <p
          className={`font-bold text-center text-base ${isValid ? "text-green-600" : "text-red-600"}`}
        >
          {title}
        </p>
        {body && <p className="text-socotec-gray-100 text-center text-sm">{body}</p>}
        <Button onClick={onClose} className="mt-1">
          Fermer
        </Button>
      </div>
    </ReactModal>
  );
};

export default CardStatusDialog;
